import { connect } from 'react-redux';
import BookingSuccess from './BookingSuccess';

const mapStateToProps = ({ siteConfiguration, user }) => ({
  settings: siteConfiguration.settings,
  profile: user.profile,
});

export default connect(mapStateToProps)(BookingSuccess);
